import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Tooltip, styled } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useGlobalConfig } from "context/GlobalContext";

const BglEVLoadCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.bglPalette.primary[200],
  minWidth: 340,
  minHeight: 110,
}));

const BglInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  color: theme.bglPalette.primary[500],
  float: "right",
}));

export interface EVLoadCardProps {
  title: String;
  count: Number;
  kW: Number;
  tooltipMsg: String;
}

export default function EVLoadCard(props: EVLoadCardProps) {
  const { rc } = useGlobalConfig();

  const { translations } = rc;

  return (
    <BglEVLoadCard>
      <CardContent>
        <div>
          <Typography
            variant="bglSubtitle2"
            sx={{ lineHeight: "34px", fontWeight: 600 }}
          >
            {translations.getTranslation(
              `EV_LOAD_MANAGEMENT.${props.title.toUpperCase()}.TITLE`
            )}
          </Typography>
          <Tooltip
            title={translations.getTranslation(
              `EV_LOAD_MANAGEMENT.${props.tooltipMsg.toUpperCase()}.TOOLTIP`
            )}
            arrow
          >
            <BglInfoIcon />
          </Tooltip>
        </div>
        <div>
          <Typography variant="bglTitle2">
            {props.count?.toLocaleString()}
          </Typography>
          <Typography variant="bglSubtitle4" sx={{ fontWeight: 600 }}>
            {" "}
            ({props.kW?.toLocaleString()} kW)
          </Typography>
        </div>
      </CardContent>
    </BglEVLoadCard>
  );
}
